/**
 * @name isArray
 * @summary Tests for a Array instance.
 */
export function isArray(value) {
    return Array.isArray(value);
}
